<template>
   <img :class= "[aniName]"  :src="imgData" @load="load"/>
</template>

<script>
    export default {
        replace: true,
        name: 'CanvasToImg',
        props: {
          texts:  Array,
          imgNum: {
            type:Number,
            default: 0
          },
          src: String,
          animate: {
            type:String,
            default: 'show'
          },
          cWidth: Number,
          cHeight: Number
        },
        data() {
            return {
              imgData: '',
              flag:0,
              ratio:0,
              ctx:null,
              canvas: null,
              images: [],
              aniName:'',
              opacity: 0,
              setBg: false
            }
        },
        created() {
            /* 初始化 */
            if(this.src) {
              this.toImg(this.src)
              return
            }
            try{
              if(localStorage.getItem('imgData')) {
                this.toImg(localStorage.getItem('imgData'))
                return
              }
            } catch (e) {
              console.log(e)
            }
            this.canvas = document.createElement('canvas')
            this.ctx = this.canvas.getContext('2d')
            const ratio = this.getPixelRatio(this.ctx)
            const dividend = 2
            this.ratio = ratio / dividend

            /* 获取预加载的图片 */
            this.$set(this,'images',this.$preImages)
            this.flag = this.$preImages.length
            if(this.flag >= this.imgNum) {
              this.drawImgs()
            }
            this.$bus.$on("loadedImg",(el) => {
              this.flag++
              el.isBg && this.setCanvas(el)
              this.drawImgs()
            })
        },
        methods: {
          setCanvas(el) {
            if(!el || !el.img) return
            const img = el.img
            this.canvas.width = img.width * this.ratio
            this.canvas.height = img.height  * this.ratio
            this.canvas.style.maxWidth = '100%'
            this.canvas.style.maxHeight = '100%'
            this.setBg = true
          },
          getPixelRatio(context) {
            const backingStore = context.backingStorePixelRatio ||
              context.webkitBackingStorePixelRatio ||
              context.mozBackingStorePixelRatio ||
              context.msBackingStorePixelRatio ||
              context.oBackingStorePixelRatio ||
              context.backingStorePixelRatio || 1;
            return (window.devicePixelRatio || 1) / backingStore;
          },
          drawImgs() {
            if(this.flag < this.imgNum) return
            if(!this.setBg) {
              const bgEl = this.images.filter((el) => {
                return el.isBg
              })
              if(bgEl.length > 1) {
                console.warn("只需设置一个isBg属性")
              }
              this.setCanvas(bgEl[0]) // preload完成在组件注册前的情况下，设置canvas宽高

              this.cWidth && (this.canvas.width = this.cWidth * this.ratio)
              this.cHeight && (this.canvas.height = this.cHeight * this.ratio)
            }
            this.images.concat().sort((a,b) => {
              // 图片按z属性排序
              const max =  10000
              let v1 = a.z != undefined ? a.z : max
              let v2 =  b.z != undefined ? b.z: max
              return v1 - v2
            }).forEach((el) => {
              const img = el.img
              const x = el.x|| 0
              const y = el.y || 0
              const w = el.w ||  img.width
              const h = el.h ||  img.height
              if(!el.isBg){
                this.ctx.rotate(-2.5*Math.PI/180)
              }
              this.ctx.drawImage(img,x *this.ratio ,y *this.ratio, w* this.ratio,
              h * this.ratio)
              if(!el.isBg) {
                this.ctx.rotate(2.5*Math.PI/180)
              }
            })
            this.drawTexts()
          },
          drawTexts() {
            if(this.texts) {
              this.texts.forEach((el) => {
                el.color && (this.ctx.fillStyle = el.color)
                const fz = +el.fz || 20
                const fontFamily = el.fontFamily || 'Microsoft-Yahei'
                this.ctx.font = `${fz * this.ratio}px ${fontFamily}`
                console.log(this.ctx.font)
                const x = el.x === 'center' ? this.canvas.width/2 - (+this.ctx.font.split('px')[0])*el.content.length/2 : (el.x *this.ratio || 0)
                this.ctx.rotate(-2.5*Math.PI/180)
                this.ctx.fillText(el.content, x , (el.y||0)*this.ratio)
                this.ctx.rotate(-2.5*Math.PI/180)
              })
            }
            this.toImg(this.canvas.toDataURL('image/png'))
          },
          toImg(imgData) {
            this.imgData = imgData
          },
          load() {
            this.aniName = this.animate
            try{
              localStorage.setItem('imgData',this.imgData)
            } catch (e) {
              console.log(e)
            }
            this.$emit('loaded',this.imgData)
          }
        },
    };
</script>


<style scoped>
  img {
    opacity: 0;
    position: absolute;
    display: block;
    width: auto;
    height: auto;
    left: 50%;
    top: 50%;
    max-width: 100%;
    //max-height: 100%;
    transform: translate(-50%,-50%);
  }
  .show {
    opacity: 1;
  }
.zoomIn {
  animation: zoomIn 0.5s both;
}

.zoomInDown {
  animation: zoomInDown 1s both;
}

.fadeIn {
  animation: fadeIn 1s both;
}

@keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  100%{
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}

@keyframes zoomInDown {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }

  100% {
    opacity: 1;
  }
}

</style>



// WEBPACK FOOTER //
// node_modules/vue-canvas-to-img/src/components/vue-canvas-to-img.vue